/**
 * Transforme un tableau de paramètres de taille en un objet
 * @param {Array} fontSizeSettings - Le tableau de paramètres de taille
 * @returns {Object} Un objet avec les tailles de police pour chaque type
 */
export const getFontSizes = (fontSizeSettings) => {
  if (!fontSizeSettings) {
    return {
      "Week": "16",
      "Shabbat": "16",
      "Holiday": "16"
    };
  }

  try {
    const settings = typeof fontSizeSettings === 'string' ? JSON.parse(fontSizeSettings) : fontSizeSettings;
    if (!Array.isArray(settings)) {
      return {
        "Week": "16",
        "Shabbat": "16",
        "Holiday": "16"
      };
    }

    return settings.reduce((acc, setting) => {
      if (setting.name && setting.size) {
        acc[setting.name] = setting.size;
      }
      return acc;
    }, {
      "Week": "16",
      "Shabbat": "16",
      "Holiday": "16"
    });
  } catch (error) {
    return {
      "Week": "16",
      "Shabbat": "16",
      "Holiday": "16"
    };
  }
};

/**
 * Récupère la taille de police pour un type spécifique
 * @param {Object} sizes - L'objet des tailles de police
 * @param {string} type - Le type pour lequel récupérer la taille
 * @returns {string} La taille de police
 */
export const getFontSize = (sizes, type) => {
  return sizes[type] || "16";
}; 